import { AbstractControl, ValidationErrors } from '@angular/forms';

export function validBirthDate(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (!value) return { required: true };

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return { invalidDate: true };
  }

  const minYear = 1900;
  const maxYear = new Date().getFullYear();
  const year = date.getFullYear();
  if (year < minYear || year > maxYear) {
    return { outOfRange: true };
  }

  // Calculate age precisely
  const today = new Date();
  let age = today.getFullYear() - date.getFullYear();
  const monthDiff = today.getMonth() - date.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < date.getDate())) {
    age--;
  }

  if (age < 16) {
    return { underage: true };
  }

  return null;
}
